import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";

import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

    const projects = [
        {
            title: "Business Startup",
            description: "Evaluation platform",
            imgUrl: projImg1,
        },
        {
            title: "Business Startup",
            description: "Vehicle rental site",
            imgUrl: projImg2,
        },
        {
            title: "Business Startup",
            description: "Ecommerce store",
            imgUrl: projImg3,
        },
        {
            title: "Business Startup",
            description: "An AI-powered smart wallet designed to revolutionize financial management for Moroccan SMEs.",
            imgUrl: projImg4,
        },
        {
            title: "Cosmos Products Catalog",
            description: "An online platform showcasing certified COSMOS cosmetic products with a smooth shopping experience and secure payment integration.",
            imgUrl: projImg5,
        },

    ];

    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col size={12}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <h2>Projects</h2>
                                    <p>Here are some of the projects I've worked on, showcasing my skills in design,
                                        development, and problem-solving. Each project represents a step in my journey
                                        as a developer, highlighting unique challenges and solutions.</p>
                                    <Row>
                                        {
                                            projects.map((project, index) => {
                                                return (
                                                    <ProjectCard
                                                        key={index}
                                                        {...project}
                                                    />
                                                )
                                            })
                                        }
                                    </Row>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2} alt="Background"/>
        </section>
    )
}
